// AutoGenerated
import { EnmBildirimTip } from "../enums/EnmBildirimTip"

export class BildirimModel {
    kullaniciAdi!: string;
    gonderimTarihi!: Date;
    icerik!: string;
    eserId!: string;
    calismaId!: string;
    bildirimTipi!: EnmBildirimTip;
    okundu!: boolean;
    koroModelId!: string;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}